import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  empty: {
    id: 'studio.4+5QaM',
    defaultMessage: 'No value selected',
  },
});
